import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { Location } from "@angular/common";
import { EntityService } from "src/app/services/entity.service";
import { ActivatedRoute } from "@angular/router";
import { Details } from "src/app/interfaces/details.interface";

@Component({
  selector: "app-entidades-detalle",
  templateUrl: "./entidades-detalle.component.html",
  styleUrls: ["./entidades-detalle.component.css"],
})
export class EntidadesDetalleComponent implements OnInit {
  public details: Details;
  private id: string = "";
  private subscription: Subscription = new Subscription();

  constructor(
    private service: EntityService,
    private location: Location,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get("id") || "";
    if (this.id) {
      this.loadEntityDetail(this.id);
    } else {
      this.close();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public close() {
    this.location.back();
  }

  get emailList(): string[] {
    return this.details?.correos
      ? this.details.correos
          .split(",")
          .map((email) => email.trim()) 
          .filter((email) => email !== "") 
      : [];
  }

  private async loadEntityDetail(id: string): Promise<void> {
    try {
      const details = await this.service.getEntityDetails(id);
      this.details = details;
    } catch (error) {
      console.log("error");
    }
  }
}
